import React from 'react';

import * as CreditActions from '../CreditActions';
import * as ActionConstants from '../../../utils/ActionConstants';
import * as CreditConstants from '../CreditConstants';
import CustomInput from '../../../common/components/CustomInput';
import CustomSelect from '../../../common/components/CustomSelect';
import * as Strings from '../../../utils/strings';
import { serializeForm, isValid } from '../creditUtils';

export default class CreditApplicationStep1 extends React.Component {
    next(e) {
        e.preventDefault();

        const form = serializeForm(this.refs);
        if (isValid(this.refs)) {
            CreditActions.goTo(CreditConstants.CREDIT_STEP2, { ...form });
        }
    }
    render() {
        //PAGE 1
        // Full Legal Name
        // Business Name
        // Business Type
        // Years in Business
        // Business Phone
        // Website

        // businessName: String
        // operatingName: String
        // businessType: String (Incorporated | Proprietorship)
        // yearsInBusiness: Integer
        // contactPhone (businessPhone): String
        // contactWebsite (website):String

        return (
            <div className="credit-application-step">
                <form onSubmit={this.next.bind(this)}>
                    <div className="form-container">
                        <div className="row">
                            <CustomInput
                                ref="businessName"
                                label={Strings.CREDIT_FULL_LEGAL_NAME}
                                placeholder={
                                    Strings.CREDIT_FULL_LEGAL_NAME_PLACEHOLDER
                                }
                                required
                            />
                            <CustomInput
                                ref="operatingName"
                                label={Strings.CREDIT_BUSINESS_NAME}
                                placeholder={
                                    Strings.CREDIT_BUSINESS_NAME_PLACEHOLDER
                                }
                            />
                        </div>
                        <div className="row">
                            <CustomSelect
                                ref="businessType"
                                label={Strings.CREDIT_BUSINESS_TYPE}
                                options={Strings.CREDIT_BUSINESS_TYPE_OPTIONS}
                            />
                            <CustomInput
                                ref="yearsInBusiness"
                                type="number"
                                label={Strings.CREDIT_YEARS_IN_BUSINESS}
                                placeholder={
                                    Strings.CREDIT_YEARS_IN_BUSINESS_PLACEHOLDER
                                }
                                required
                            />
                        </div>
                        <div className="row">
                            <CustomInput
                                ref="contactPhone"
                                label="Business Phone"
                                placeholder="555-555-5555"
                                required
                            />
                            <CustomInput
                                ref="contactWebsite"
                                label="Business Website"
                                placeholder="google.com"
                            />
                        </div>
                    </div>
                    <button className="right green">
                        {' '}
                        {Strings.CREDIT_BTN_NEXT}
                    </button>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/credit/components/CreditApplicationStep1.jsx